import { useEffect } from 'react';
import { useLogger } from '~/common/context';
import { INTERNAL_SUPPORTED_EVENTS } from '~/common/helpers';
import { useMyCustomersProbe } from '~/common/hooks';
import { usePurchaseContext } from '~/purchase/context';

export const useReloadCustomerListener = () => {
  const { handlers } = usePurchaseContext();
  const logger = useLogger();
  const customersProbe = useMyCustomersProbe();

  useEffect(() => {
    const handleReloadCustomers = () => {
      void customersProbe.refetch().then((result) => {
        if (result.data && result.data.length === 1) {
          const customer = result.data[0];
          logger.info('Reload Customers Event: Setting primary customer', {
            customerId: customer.value,
          });
          handlers.setPrimaryCustomerId(customer.value);
        }
      });
    };

    window.addEventListener(
      INTERNAL_SUPPORTED_EVENTS.RELOAD_CUSTOMER,
      handleReloadCustomers,
    );

    return () => {
      window.removeEventListener(
        INTERNAL_SUPPORTED_EVENTS.RELOAD_CUSTOMER,
        handleReloadCustomers,
      );
    };
  }, [customersProbe, handlers, logger]);
};
